import { render, staticRenderFns } from "./complete-sliders.vue?vue&type=template&id=1742f182&"
import script from "./complete-sliders.vue?vue&type=script&lang=js&"
export * from "./complete-sliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports